import { render, staticRenderFns } from "./UcCompanyBankAccounts.yaml?vue&type=template&id=a501282a&component"
import script from "./UcCompanyBankAccounts.yaml?vue&type=script&lang=ts&component"
export * from "./UcCompanyBankAccounts.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports